import styled from "styled-components";

export const ImgWrapper = styled.img`
  width: 100%;
`;
